import React from 'react';

const Notice = () => {
  return (
    <svg
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.59898 13.4473H16.9323V30.1139H8.59898C7.49392 30.1139 6.43417 29.675 5.65277 28.8935C4.87135 28.1121 4.43231 27.0523 4.43231 25.9473V17.6139C4.43231 16.5089 4.87135 15.4491 5.65277 14.6676C6.43417 13.8862 7.49392 13.4473 8.59898 13.4473Z"
        fill="#5096FF"
      />
      <path d="M13.2865 30.114H8.07812V44.6973H13.2865V30.114Z" fill="#5096FF" />
      <path
        d="M39.8489 15.5305C41.5064 15.5305 43.0962 16.189 44.2683 17.3611C45.4404 18.5332 46.0989 20.1229 46.0989 21.7805C46.0989 23.438 45.4404 25.0278 44.2683 26.1999C43.0962 27.372 41.5064 28.0305 39.8489 28.0305V15.5305Z"
        fill="#5096FF"
      />
      <path
        d="M38.3698 39.8833L16.9323 30.1333V13.4666L38.3698 3.8207C38.5279 3.74751 38.7019 3.71518 38.8756 3.72661C39.0496 3.73805 39.2177 3.7929 39.365 3.8862C39.5121 3.97947 39.6336 4.1082 39.7181 4.26053C39.8027 4.41288 39.8477 4.58399 39.849 4.75824V39.0291C39.8346 39.1962 39.78 39.3573 39.69 39.4987C39.6 39.6402 39.4773 39.7579 39.3321 39.8418C39.1869 39.9256 39.0236 39.9731 38.8561 39.9804C38.6886 39.9875 38.5217 39.9543 38.3698 39.8833Z"
        fill="#CBDFFF"
      />
    </svg>
  );
};

export default Notice;
